import React from 'react';
import { useTranslation } from "react-i18next";

interface DiscoverySectionItemProps {
    isDineIn: boolean;
    image: string;
    name: string;
    priceBefore: number;
    priceNow: number;
    discount: number;
    address: string;
    onOption?: string;
}

const DiscoverySectionItem = (props: DiscoverySectionItemProps) => {
    const { t } = useTranslation();

    return (
      <div className="discoverySectionItem__container">
          <div className="discoverySectionItem__container-wrap">
              <div className="discoverySectionItem__container-data-image">
                  <div className="discoverySectionItem__container-data-reservation-wrap">
                      <div className={`discoverySectionItem__container-data-reservation`}>
                          <span>{props.isDineIn ? t('const.dineIn') : t('const.takeOut')}</span>
                      </div>
                  </div>
                  <img src={props.image} alt={props.name} />
              </div>

              <div className="discoverySectionItem__container-data-place-wrap">
                  <div className="discoverySectionItem__container-data-place">
                      <span>{props.address}</span>
                  </div>
                  {
                      props.isDineIn ? (
                      <div className="discoverySectionItem__container-data-options-wrap">
                          {
                            props.onOption && props.onOption.length > 0 && (
                              <div className="discoverySectionItem__container-data-options">
                                  <span>{t(`const.${props.onOption.toLowerCase()}`)}</span>
                              </div>
                            )
                          }
                      </div>
                    ) : (
                        <div className="discoverySectionItem__container-data-price before">
                            {props.priceBefore && !isNaN(props.priceBefore) && (
                              <span>{`€${props.priceBefore}`}</span>
                            )}
                        </div>
                      )
                  }
              </div>

              <div className="discoverySectionItem__container-data-wrap">
                  <div className="discoverySectionItem__container-data-name">
                      <span>{props.name}</span>
                  </div>
                  {
                      props.isDineIn ? (
                        <div className="discoverySectionItem__container-data-price-wrap">
                            <div className="discoverySectionItem__container-data-discount-dine-in">
                                <span>{props.discount}% {t('const.discount')}</span>
                            </div>
                        </div>
                      ) : (
                        <div className="discoverySectionItem__container-data-price-wrap">
                            <div className="discoverySectionItem__container-data-price before">
                                {props.priceBefore && !isNaN(props.priceBefore) && (
                                  <span>{`€${props.priceBefore}`}</span>
                                )}
                            </div>
                            <div className="discoverySectionItem__container-data-price now">
                                {props.priceNow && !isNaN(props.priceNow) && (
                                  <span>{`€${props.priceNow}`}</span>
                                )}
                            </div>
                        </div>
                      )
                  }

              </div>
          </div>
      </div>
    );
};

export default DiscoverySectionItem;
